export const PASSWORD_MIN_LENGTH = 6;

export const passwordIssue = (value) => {
  if (typeof value !== "string" || !value.length) return "PASSWORD_REQUIRED";
  const length = Array.from(value).length;
  if (length < PASSWORD_MIN_LENGTH) return "PASSWORD_MIN_LENGTH";
  return "";
};

const passwordKeys = {
  PASSWORD_REQUIRED: "passwordRequired",
  PASSWORD_MIN_LENGTH: "passwordMinLength",
  CURRENT_PASSWORD_INCORRECT: "currentPasswordIncorrect",
};

export const passwordMessage = (code, t) => t(passwordKeys[code] || "toast.generic");

export const apiValidationMessage = (error, t) => {
  if (passwordKeys[error?.code]) return passwordMessage(error.code, t);
  if (error?.path === "currentPassword") return t("validation.current-password-required");
  if (error?.path === "fullName") return t("validation.name_invalid");
  if (error?.path === "email") return t("validation.email_invalid");
  if (error?.path === "confirmPassword") return t("validation.password-match");
  if (error?.path === "captchaToken") return t("registrationSecurityRequired");
  return t("validation.invalidInput");
};

export const apiErrorMessage = (data, t) => {
  if (data?.errors?.length) return apiValidationMessage(data.errors[0], t);
  if (passwordKeys[data?.code]) return passwordMessage(data.code, t);
  return t("toast.generic");
};
